var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 127,
    viewBox: "0 0 87 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 127,
    fill: "#F94F79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1777 78V49.6364H30.476C32.6365 49.6364 34.4508 49.9272 35.9189 50.5089C37.3961 51.0906 38.5087 51.9123 39.2566 52.9741C40.0137 54.0359 40.3922 55.2869 40.3922 56.7273C40.3922 57.7706 40.1614 58.7216 39.6998 59.5803C39.2473 60.4389 38.6103 61.1591 37.7885 61.7408C36.9668 62.3132 36.0066 62.7102 34.9078 62.9318V63.2088C36.1266 63.255 37.2346 63.5643 38.2317 64.1367C39.2289 64.6999 40.0229 65.4801 40.6138 66.4773C41.2047 67.4652 41.5002 68.6286 41.5002 69.9673C41.5002 71.5185 41.0939 72.8988 40.2814 74.1083C39.4782 75.3178 38.3333 76.2688 36.8468 76.9613C35.3603 77.6538 33.5875 78 31.5286 78H18.1777ZM25.878 71.8509H29.4789C30.7715 71.8509 31.7409 71.6108 32.3873 71.1307C33.0336 70.6413 33.3567 69.9212 33.3567 68.9702C33.3567 68.3054 33.2044 67.7422 32.8997 67.2805C32.595 66.8189 32.161 66.468 31.5978 66.228C31.0439 65.9879 30.3745 65.8679 29.5897 65.8679H25.878V71.8509ZM25.878 61.1037H29.0357C29.7097 61.1037 30.3052 60.9975 30.8223 60.7852C31.3393 60.5728 31.7409 60.2681 32.0272 59.8711C32.3226 59.4648 32.4703 58.9709 32.4703 58.3892C32.4703 57.5121 32.1564 56.8427 31.5286 56.381C30.9007 55.9102 30.1067 55.6747 29.1465 55.6747H25.878V61.1037ZM44.2285 78V49.6364H51.9288V60.7159H62.122V49.6364H69.8223V78H62.122V66.9205H51.9288V78H44.2285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup15);
export default __webpack_public_path__ + "static/media/Group 15.1ada71f89dbdf26ecc4cef276fe360b4.svg";
export { ForwardRef as ReactComponent };